import React from 'react';
import { UploadElement } from 'is24-corecss';
import type { UploadElementStatus } from 'is24-corecss/build/@types/UploadElement';
import { IconS24CrossCircle24Filled, IconS24DocumentPlus24 } from '@is24/cosma-ui-icons';
import { useTranslation } from 'react-i18next';

interface FileUploadProps {
  title: string;
  subtitle: string;
  accept?: string;
  status?: UploadElementStatus;
  onFileSelect?: (files: FileList) => void;
}

export const FileUpload: React.FC<FileUploadProps> = ({ title, subtitle, accept, status = 'empty', onFileSelect }) => {
  const { t } = useTranslation();

  return (
    <UploadElement.Root onFileSelect={onFileSelect} status={status} accept={accept}>
      <UploadElement.Dropzone>
        <UploadElement.Icon>
          <IconS24DocumentPlus24 />
        </UploadElement.Icon>
        <UploadElement.Content>
          <UploadElement.Title>{title}</UploadElement.Title>
          <UploadElement.Description>{subtitle}</UploadElement.Description>
        </UploadElement.Content>
      </UploadElement.Dropzone>
      <UploadElement.Error>
        <IconS24CrossCircle24Filled />
        {t('FileUpload.error')}
      </UploadElement.Error>
    </UploadElement.Root>
  );
};
export default FileUpload;
